(function () {
    'use strict';

    angular.module("imApp").factory("coopLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listCoopLanguages: function (parms) {
                return $ihttp.post({
                    method: 2730,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2731,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
